import gql from "graphql-tag";

export const IMPORT_GLOBAL_ASSET = gql`
  mutation ImportGlobalAsset($costumeFeatureId: ID!, $costumeTypeId: ID!) {
    importGlobalAsset(
      costumeFeatureId: $costumeFeatureId
      costumeTypeId: $costumeTypeId
    ) {
      id
      name
      isCommon
      section {
        id
        name
      }
      costumeType {
        id
        name
      }
    }
  }
`;
